import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ZigLink, ZigStub } from '@ui/index';

const CloudflareBlocked: React.FC = () => {
  const { t } = useTranslation('error');

  return (
    <ZigStub
      title={t('critical-cloudflare-error.title')}
      description={
        <Trans t={t} i18nKey={'error:critical-cloudflare-error.description'}>
          <ZigLink onClick={() => window.location.reload()} target={'_self'} />
        </Trans>
      }
    />
  );
};

export default CloudflareBlocked;
